import type { MessageDescriptor } from 'react-intl';

import { Position } from 'config/positions';
import { routes } from 'config/routes';

export enum InquiryType {
    BASIC = 'basic',
    WITH_IMAGE = 'withImage',
    CAREER = 'career',
}

interface Item {
    title: MessageDescriptor['id'];
    cta: MessageDescriptor['id'];
    link: string;
}

type Content = { [key in InquiryType]: Item };

export const content: Omit<Content, InquiryType.WITH_IMAGE> = {
    [InquiryType.BASIC]: {
        title: 'inquiry.section.title',
        cta: 'inquiry.section.cta',
        link: routes['/contact'],
    },
    [InquiryType.CAREER]: {
        title: 'careerPage.inquiry.title',
        cta: 'careerPage.inquiry.cta',
        link: routes.positions[Position.NOT_FOUND],
    },
} as const;
